import React from 'react';
import { CheckCircle2, Users, School, ChefHat, MapPin, BarChart3, TrendingUp, Bell, MessageSquare, FileText, Settings, Code, Zap, DollarSign, CreditCard, Lock, Globe, Target, Heart, UserPlus, Share2, FileImage } from 'lucide-react';

export const ParentsTab = () => (
  <div className="tab-content">
    <div className="tab-content-header">
      <Users size={40} className="tab-icon" />
      <div>
        <h3>Portail Parents</h3>
        <p>Interface familiale intuitive avec gestion multi-enfants</p>
      </div>
    </div>

    <div className="pricing-plans">
      <div className="plan-card">
        <div className="plan-header">
          <h4>💚 Gratuit</h4>
          <div className="plan-price">
            <span className="price">0$</span>
            <span className="period">/mois</span>
          </div>
        </div>
        <ul className="plan-features">
          <li><CheckCircle2 size={18} /> Connexion simplifiée</li>
          <li><CheckCircle2 size={18} /> Gestion allergies intelligente</li>
          <li><CheckCircle2 size={18} /> Mémoire préférences (smileys)</li>
          <li><CheckCircle2 size={18} /> Notifications par courriel</li>
          <li><CheckCircle2 size={18} /> Paiement sécurisé</li>
          <li><CheckCircle2 size={18} /> Sezzle - Paiement fractionné</li>
          <li><CheckCircle2 size={18} /> Commande Rapide - Repas du Jour</li>
        </ul>
      </div>

      <div className="plan-card featured">
        <div className="plan-badge">✨ POPULAIRE</div>
        <div className="plan-header">
          <h4>✨ Plus</h4>
          <div className="plan-price">
            <span className="price">2,00$</span>
            <span className="period">/mois</span>
          </div>
        </div>
        <ul className="plan-features">
          <li><CheckCircle2 size={18} /> Tout Gratuit +</li>
          <li><CheckCircle2 size={18} /> Téléchargement/Impression menus</li>
          <li><CheckCircle2 size={18} /> Thèmes Personnalisés</li>
          <li><CheckCircle2 size={18} /> Synchronisation calendrier</li>
          <li><CheckCircle2 size={18} /> Code couleur par enfant</li>
          <li><CheckCircle2 size={18} /> 50% reversé à l'école</li>
        </ul>
      </div>

      <div className="plan-card premium">
        <div className="plan-badge">⭐ SIGNATURE</div>
        <div className="plan-header">
          <h4>⭐ Signature</h4>
          <div className="plan-price">
            <span className="price">2,99$</span>
            <span className="period">/mois</span>
          </div>
        </div>
        <ul className="plan-features">
          <li><CheckCircle2 size={18} /> Tout Plus +</li>
          <li><CheckCircle2 size={18} /> Personnalisation menu commande</li>
          <li><CheckCircle2 size={18} /> C1C (Commande en 1 Clic)</li>
          <li><CheckCircle2 size={18} /> Abonnement repas automatique</li>
          <li><CheckCircle2 size={18} /> Notifications SMS & Push</li>
          <li><CheckCircle2 size={18} /> <strong>Portail Enfant complet</strong></li>
          <li><CheckCircle2 size={18} /> Jeu CliC & CroQ™</li>
          <li><CheckCircle2 size={18} /> Création d'Avatars</li>
          <li><CheckCircle2 size={18} /> 50% reversé à l'école</li>
        </ul>
      </div>
    </div>

    <div className="revenue-split">
      <h4>💚 Où va votre argent?</h4>
      <div className="split-grid">
        <div className="split-card">
          <div className="split-percentage">50%</div>
          <h5>→ Soutien à l'École</h5>
          <p>Matériel scolaire, activités pédagogiques, projets et événements pour les élèves</p>
          <span className="split-badge">✓ Reçu fiscal automatique</span>
        </div>
        <div className="split-card">
          <div className="split-percentage">50%</div>
          <h5>→ Plateforme EcoLunch</h5>
          <p>Entretien, Support, Évolution & Ajouts de nouvelles fonctionnalités</p>
          <span className="split-badge">✓ Meilleure expérience pour vous</span>
        </div>
      </div>
    </div>
  </div>
);

export const SchoolsTab = () => (
  <div className="tab-content">
    <div className="tab-content-header">
      <School size={40} className="tab-icon" />
      <div>
        <h3>Portail École</h3>
        <p>Cockpit de gestion scolaire - Outil de pilotage pour satisfaction alimentaire</p>
      </div>
    </div>

    <div className="features-grid">
      <div className="feature-block">
        <BarChart3 size={28} className="feature-icon" />
        <h4>Vue Quotidienne</h4>
        <ul>
          <li>Repas commandés en temps réel</li>
          <li>Gestion des absences</li>
          <li>Ajustements temps réel</li>
          <li>Volumes par classe/niveau</li>
        </ul>
      </div>

      <div className="feature-block">
        <TrendingUp size={28} className="feature-icon" />
        <h4>Satisfaction</h4>
        <ul>
          <li>Score moyen 30 jours</li>
          <li>Tendances d'évolution</li>
          <li>Analyse par plat</li>
          <li>Feedback parents automatique</li>
        </ul>
      </div>

      <div className="feature-block">
        <Bell size={28} className="feature-icon" />
        <h4>Alertes Intelligentes</h4>
        <ul>
          <li>Plats sous seuil configurable</li>
          <li>Retards de livraison</li>
          <li>Alertes automatiques</li>
          <li>Notifications push personnalisées</li>
        </ul>
      </div>

      <div className="feature-block">
        <MessageSquare size={28} className="feature-icon" />
        <h4>Communication</h4>
        <ul>
          <li>Canal direct traiteur</li>
          <li>Direction d'école</li>
          <li>Chat intégré temps réel</li>
          <li>Partage de fichiers sécurisé</li>
        </ul>
      </div>

      <div className="feature-block">
        <FileText size={28} className="feature-icon" />
        <h4>Rapports</h4>
        <ul>
          <li>Automatisables</li>
          <li>Personnalisables</li>
          <li>Format flexible (Excel, PDF)</li>
          <li>Fréquence ajustable</li>
          <li>Historique complet</li>
        </ul>
      </div>

      <div className="feature-block">
        <Settings size={28} className="feature-icon" />
        <h4>Paramétrages</h4>
        <ul>
          <li>Seuil satisfaction configurable</li>
          <li>Délai avant alerte</li>
          <li>Rapports automatiques planifiables</li>
          <li>Permissions par rôle (Directeur, Secrétaire)</li>
          <li>Accès limité à l'établissement</li>
        </ul>
      </div>
    </div>
  </div>
);

export const CaterersTab = () => (
  <div className="tab-content">
    <div className="tab-content-header">
      <ChefHat size={40} className="tab-icon" />
      <div>
        <h3>Portail Traiteur</h3>
        <p>Back-office complet de gestion avec automatisation IA</p>
      </div>
    </div>

    <div className="pricing-plans">
      <div className="plan-card">
        <div className="plan-header">
          <h4>⚡ Essentiel</h4>
          <div className="plan-price">
            <span className="price">250$</span>
            <span className="period">/mois</span>
          </div>
          <p className="plan-seats">1 Seat inclus</p>
        </div>
        <ul className="plan-features">
          <li><CheckCircle2 size={18} /> Mise en ligne menus & commandes</li>
          <li><CheckCircle2 size={18} /> Rapports détaillés (élève, classe, date)</li>
          <li><CheckCircle2 size={18} /> Rapports de production</li>
          <li><CheckCircle2 size={18} /> Exportation (CSV, Excel, PDF)</li>
          <li><CheckCircle2 size={18} /> Multi-écoles / multi-sites</li>
          <li><CheckCircle2 size={18} /> Multilingue (FR/EN)</li>
          <li><CheckCircle2 size={18} /> Modifications temps réel</li>
          <li><CheckCircle2 size={18} /> Gestion allergènes complète</li>
          <li><CheckCircle2 size={18} /> Messagerie interne EcoLoop™</li>
          <li><CheckCircle2 size={18} /> Support VIP 24/7</li>
        </ul>
      </div>

      <div className="plan-card featured">
        <div className="plan-badge">⭐ POPULAIRE</div>
        <div className="plan-header">
          <h4>🚀 Plus</h4>
          <div className="plan-price">
            <span className="price">500$</span>
            <span className="period">/mois</span>
          </div>
          <p className="plan-seats">2 Seats inclus</p>
        </div>
        <ul className="plan-features">
          <li><CheckCircle2 size={18} /> <strong>Tout Essentiel +</strong></li>
          <li><CheckCircle2 size={18} /> <strong>ReportIQ™ - IA automatisation</strong></li>
          <li><CheckCircle2 size={18} /> Statistiques avancées (plats populaires)</li>
          <li><CheckCircle2 size={18} /> Tendances & % annulation</li>
          <li><CheckCircle2 size={18} /> Temps passés par utilisateurs</li>
          <li><CheckCircle2 size={18} /> Co-Branding complet</li>
          <li><CheckCircle2 size={18} /> Accompagnement stratégique</li>
          <li><CheckCircle2 size={18} /> Implantation complète</li>
          <li><CheckCircle2 size={18} /> Tableaux de bord analytique</li>
          <li><CheckCircle2 size={18} /> Personnalisation visuelle avancée</li>
        </ul>
      </div>
    </div>

    <div className="premium-modules">
      <h4>🎁 Modules Premium Disponibles</h4>
      <div className="modules-grid">
        <div className="module-card">
          <Code size={24} />
          <h5>API Systèmes Actuels</h5>
          <p>Intégrations: QuickBooks, Sage, Acomba & Acomba GO. Centralisation complète.</p>
          <span className="module-price">Prix selon complexité</span>
        </div>
        <div className="module-card">
          <Zap size={24} />
          <h5>QPlanIQ™</h5>
          <p>Auto-commande IA. Calcul ingrédients, prédictions intelligentes, optimisation des coûts.</p>
          <span className="module-price">À venir - Juillet 2026</span>
        </div>
        <div className="module-card">
          <TrendingUp size={24} />
          <h5>LogistIQ™</h5>
          <p>Gestion intelligente livraisons. Optimisation routes/horaires avec IA propriétaire.</p>
          <span className="module-price">Prix selon besoins</span>
        </div>
      </div>
    </div>

    <div className="backoffice-features">
      <h4>🏭 Back-Office Complet</h4>
      <div className="backoffice-grid">
        <div className="backoffice-item">
          <FileText size={20} />
          <span>Commandes - Affichage, tri, annulations automatiques</span>
        </div>
        <div className="backoffice-item">
          <FileText size={20} />
          <span>Menus - Duplication facile, variations par école</span>
        </div>
        <div className="backoffice-item">
          <BarChart3 size={20} />
          <span>Production - Agrégation auto, volumes temps réel</span>
        </div>
        <div className="backoffice-item">
          <DollarSign size={20} />
          <span>Comptabilité - QuickBooks, Sage, Acomba intégrés</span>
        </div>
        <div className="backoffice-item">
          <CreditCard size={20} />
          <span>Paiements - Clover (Visa/Master), rapports financiers</span>
        </div>
        <div className="backoffice-item">
          <Bell size={20} />
          <span>Alertes - Automatiques personnalisables, seuils configurables</span>
        </div>
      </div>
    </div>
  </div>
);

export const DirectionsTab = () => (
  <div className="tab-content">
    <div className="tab-content-header">
      <MapPin size={40} className="tab-icon" />
      <div>
        <h3>Portail Direction d'École</h3>
        <p>Coordination territoriale - Supervision multi-établissements</p>
      </div>
    </div>

    <div className="features-grid">
      <div className="feature-block">
        <Globe size={28} className="feature-icon" />
        <h4>Vue Consolidée</h4>
        <ul>
          <li>Volumes agrégés par école</li>
          <li>Satisfaction moyenne du portefeuille</li>
          <li>Alertes actives en temps réel</li>
          <li>Vue d'ensemble territoriale</li>
          <li>Indicateurs clés de performance (KPIs)</li>
        </ul>
      </div>

      <div className="feature-block">
        <BarChart3 size={28} className="feature-icon" />
        <h4>Analyse Comparative</h4>
        <ul>
          <li>Performance traiteur / école</li>
          <li>Comparatifs de portefeuille</li>
          <li>Identification des tendances</li>
          <li>Benchmarking régional</li>
          <li>Rapports d'écarts et recommandations</li>
        </ul>
      </div>

      <div className="feature-block">
        <FileText size={28} className="feature-icon" />
        <h4>Rapports de Portefeuille</h4>
        <ul>
          <li>Export PDF/Excel automatisés</li>
          <li>Rapports personnalisables</li>
          <li>Planification flexible</li>
          <li>Tableaux de bord stratégiques</li>
          <li>Historique complet multi-années</li>
        </ul>
      </div>

      <div className="feature-block">
        <MessageSquare size={28} className="feature-icon" />
        <h4>Communication Multi-Acteurs</h4>
        <ul>
          <li>Canal écoles ↔ traiteurs</li>
          <li>Coordination multi-établissements</li>
          <li>Chat intégré multi-acteurs</li>
          <li>Intervention sans permission requise</li>
          <li>Partage de documents et directives</li>
        </ul>
      </div>

      <div className="feature-block">
        <Lock size={28} className="feature-icon" />
        <h4>Journalisation & Audit</h4>
        <ul>
          <li>Toutes actions traçables</li>
          <li>Audit complet (lecture, modification)</li>
          <li>Conformité garantie</li>
          <li>Historique des décisions</li>
          <li>Traçabilité IP et horodatage</li>
        </ul>
      </div>

      <div className="feature-block">
        <Target size={28} className="feature-icon" />
        <h4>Gouvernance & Alertes</h4>
        <ul>
          <li>Indicateurs stratégiques</li>
          <li>Alertes critiques automatiques</li>
          <li>Règles paramétrables</li>
          <li>Escalade automatique</li>
          <li>Politiques alimentaires centralisées</li>
        </ul>
      </div>
    </div>
  </div>
);

export default { ParentsTab, SchoolsTab, CaterersTab, DirectionsTab };